/**
 * user_type：
 * developer
 * manager 管理員
 * admin 行政
 * tutor 導師
 * clerk 文員
 * student
 */

function _getCannotAccessList(config) {
  let _cannotAccessList = {
    // 繳交學費
    'PayTuitionList': ['tutor', 'tutor1', 'tutor2', 'student'],
    'PayTuitionList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'student'],
    'PayTuitionPayment': ['tutor', 'tutor1', 'tutor2', 'student'],
    'PayTuitionPayment_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'student'],
    // 調堂要求
    'SwitchRequirement': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SwitchRequirement_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SwitchRequirement_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'StudentSwitchRequirement': ['developer', 'manager', 'admin', 'tutor', 'tutor1', 'tutor2', 'clerk'],
    // 課程時間表
    'Timetable': ['student'],
    'Timetable_T21': ['admin', 'student'],
    'CreateClass': ['tutor', 'tutor1', 'tutor2', 'student'],
    'CreateClass_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'student'],
    'CreateClass_T38': ['student'],
    'ClassDetails': ['student'],
    'ClassDetails_T21': ['admin', 'student'],
    //學生管理
    'StudentList': ['tutor', 'tutor2', 'student'],
    'StudentDetails': ['tutor2', 'student'],
    'StudentDetails_T38': ['tutor', 'tutor1', 'tutor2', 'student'],
    'StudentUserDetails': ['developer', 'manager', 'admin', 'tutor', 'tutor1', 'tutor2', 'clerk'],
    'CreateStudent': ['tutor', 'tutor1', 'tutor2', 'student'],
    'StudentAttendance': ['tutor', 'tutor1', 'tutor2', 'student'],
    'StudentAttendance_T79': ['student'],
    'StudentUserAttendance': ['developer', 'manager', 'admin', 'tutor', 'tutor1', 'tutor2', 'clerk'],
    'StudentPoints': ['tutor', 'tutor1', 'tutor2', 'student'],
    'StudentUserPoints': ['developer', 'manager', 'admin', 'tutor', 'tutor1', 'tutor2', 'clerk'],
    //課程管理 / 線上課程
    'CourseList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CourseList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CourseDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CourseDetails_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateCourse': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateCourse_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CourseCategoryList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CourseCategoryList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateCourseCategory': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateCourseCategory_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CourseCategoryDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CourseCategoryDetails_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    //組別管理
    'GradeSetting': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'GradeSetting_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    //訂單紀錄
    'OrderList': ['tutor', 'tutor1', 'tutor2', 'student'],
    'StudentUserOrderList': ['developer', 'manager', 'admin', 'tutor', 'tutor1', 'tutor2', 'clerk'],
    //商品管理
    'ProductList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductList_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductDetails_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductDetails_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateProduct': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateProduct_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateProduct_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductCategoryList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductCategoryList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductCategoryList_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateProductCategory': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateProductCategory_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateProductCategory_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductCategoryDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductCategoryDetails_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ProductCategoryDetails_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    //套票管理
    'PackageList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'PackageList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'PackageList_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'PackageDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'PackageDetails_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'PackageDetails_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreatePackage': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreatePackage_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreatePackage_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    //月票管理
    'MonthPassList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'MonthPassList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'MonthPassList_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'MonthPassDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'MonthPassDetails_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'MonthPassDetails_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateMonthPass': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateMonthPass_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateMonthPass_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    //分校管理
    'SchoolList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SchoolList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SchoolList_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SchoolList_T60': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SchoolDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SchoolDetails_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SchoolDetails_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SchoolDetails_T60': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateSchool': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateSchool_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateSchool_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateSchool_T46': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateSchool_T60': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    //課室管理
    'ClassroomList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ClassroomList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ClassroomList_T38': ['admin', 'clerk', 'student'],
    'ClassroomDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ClassroomDetails_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'ClassroomDetails_T38': ['admin', 'clerk', 'student'],
    'CreateClassroom': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateClassroom_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateClassroom_T38': ['admin', 'clerk', 'student'],
    //導師管理
    'TutorList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'TutorList_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'TutorDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'TutorDetails_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateTutor': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateTutor_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateTutor_T46': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SalaryReport': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SalaryReport_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'SalaryReport_T79': ['admin','tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'TutorCalendar': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'TutorCalendar_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'TutorLeave': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'TutorUserLeave': ['developer', 'manager', 'admin', 'clerk', 'student'],
    // 推廣活動
    'CouponList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CouponList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CouponDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CouponDetails_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateCoupon': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateCoupon_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    // 推送通知
    'NotifyList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'NotifyList_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'NotifyList_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'NotifyDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'NotifyDetails_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'NotifyDetails_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateNotify': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateNotify_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateNotify_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    //Blog
    'BlogCategoryList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'BlogCategoryDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateBlogCategory': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'BlogList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'BlogDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateBlog': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'StudentBlogList': ['developer', 'manager', 'admin', 'tutor', 'tutor1', 'tutor2', 'clerk'],
    'StudentBlogDetails': ['developer', 'manager', 'admin', 'tutor', 'tutor1', 'tutor2', 'clerk'],
    //教學影片
    'VideoCategoryList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'VideoCategoryDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateVideoCategory': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'VideoList': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'VideoDetails': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'CreateVideo': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    // 設定
    'Setting': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'Setting_T21': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'Setting_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    // 報表
    'Report': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'Report_T38': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'Report_T79': ['admin','clerk', 'student'],
    // 查詢
    'Enquiry': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    // action
    'editStudent': ['tutor', 'tutor1'],
    'upgradeStudent': ['tutor', 'tutor1', 'tutor2', 'student'], // 學生升級
    'quitAndRemissStudent': ['tutor', 'tutor1', 'tutor2', 'student'], // 學生退學/重新入學
    'blockStudent': ['tutor', 'tutor1', 'tutor2', 'student'], // 學生 限制登入/解除登入限制
    'blockStaff': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'], // Staff 限制登入/解除登入限制
    'advancedEditOrder': ['tutor', 'tutor1', 'tutor2', 'student'], // 作廢發票/審核付款/退款
    'editOrder': ['tutor', 'tutor1', 'tutor2', 'student'], // 修改訂單
    'canAuditReq': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'], // 調堂要求 (接受/拒絕)
    'editClass': ['tutor', 'tutor1', 'tutor2', 'student'], // update 課堂資訊, 課程其他課堂
    'editClass_T38': ['student'],
    'editClass_T30': ['student'],
    'editClass_T47': ['student'],
    'editAttendance': ['student'], // update 學生出席狀態
    'editStudentPoints': ['tutor', 'tutor1', 'tutor2', 'student'], // 新增/扣減積分
    'viewSalary': ['admin', 'tutor', 'tutor1', 'tutor2', 'clerk', 'student'], // view 導師薪酬 related
    'viewSalary_T46': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'viewSalary_T60': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'],
    'canAuditLeave': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'], // 請假申請 (接受/拒絕) / 導師attendance
    'viewLog': ['tutor', 'tutor1', 'tutor2', 'clerk', 'student'], // view Log Record
  }
  let _cannotAccessList_dup = JSON.parse(JSON.stringify(_cannotAccessList));
  for (let key in _cannotAccessList_dup) {
    if (_cannotAccessList_dup[`${key}_${config.VUE_APP_RUN_MODE}`] !== undefined) {
      _cannotAccessList[key] = _cannotAccessList_dup[`${key}_${config.VUE_APP_RUN_MODE}`];

      if (_cannotAccessList[`${key}_${config.VUE_APP_RUN_MODE}`] !== undefined) {
        delete _cannotAccessList[`${key}_${config.VUE_APP_RUN_MODE}`];
      }
    }
  }

  return _cannotAccessList;
}
function _getDefaultPages(config) {
  const _cannotAccessList = _getCannotAccessList(config);
  let ImportStatic = null;
  try {
    ImportStatic = require(`@/static/${config.VUE_APP_RUN_MODE}`);
  } catch (e) {
    ImportStatic = null
  }
  let defaultPageList = ['PayTuitionList', 'SwitchRequirement', 'Timetable', 'TutorUserLeave', 'StudentList', 'StudentUserDetails', 'StudentSwitchRequirement', 'StudentUserAttendance', 'StudentUserOrderList', 'CourseCategoryList', 'GradeSetting', 'OnlineCourseCategoryList', 'OrderList', 'ProductList', 'PackageList', 'MonthPassList', 'SchoolList', 'ClassroomList', 'TutorList', 'CouponList', 'NotifyList', 'BlogCategoryList', 'VideoCategoryList', 'WebsiteHomeSetting', 'AboutUs', 'StudentBlogList', 'BasicSetting', 'Report'];
  if (ImportStatic !== undefined && ImportStatic !== null && ImportStatic.defaultPageList !== undefined && ImportStatic.defaultPageList !== null) {
    defaultPageList = ImportStatic.defaultPageList;
  }
  const _defaultPages = {
    developer: [],
    manager: [],
    admin: [],
    tutor: [],
    tutor1: [],
    tutor2: [],
    student: [],
    clerk: [],
  };
  for (let type in _defaultPages) {
    let list = JSON.parse(JSON.stringify(defaultPageList));
    for (let i = list.length - 1; i >= 0; i--) {
      if (_cannotAccessList[defaultPageList[i]] && _cannotAccessList[defaultPageList[i]].includes(type)) {
        list.splice(i, 1);
      }
    }
    _defaultPages[type] = list;
  }
  return _defaultPages;
}

function _getUserTypeGrade(config) {
  const userTypeGrade = {
    developer: ['manager', 'admin', 'tutor', 'clerk'],
    manager: ['manager', 'admin', 'tutor', 'clerk'],
    admin: ['admin', 'tutor', 'clerk'],
    tutor: ['tutor'],
    // tutor2: ['tutor2'],
    clerk: ['clerk'],
  }

  if (config.VUE_APP_RUN_MODE === 'T01') {
    userTypeGrade['developer'] = ['manager', 'admin', 'tutor', 'tutor1', 'clerk']
    userTypeGrade['manager'] = ['manager', 'admin', 'tutor', 'tutor1', 'clerk']
    userTypeGrade['admin'] = ['admin', 'tutor', 'tutor1', 'clerk']
    userTypeGrade['tutor1'] = ['tutor1']
  }

  if (config.VUE_APP_RUN_MODE === 'T60') {
    // cancel in 2026/06/02
    // userTypeGrade['admin'] = ['tutor', 'tutor2', 'clerk'];
  }

  if (config.VUE_APP_RUN_MODE === 'T46') {
    userTypeGrade['developer'] = ['manager', 'admin', 'tutor', 'tutor2', 'clerk']
    userTypeGrade['manager'] = ['manager', 'admin', 'tutor', 'tutor2', 'clerk']
    userTypeGrade['admin'] = ['admin', 'tutor', 'tutor2', 'clerk']
    userTypeGrade['tutor2'] = ['tutor2']
  }

  return userTypeGrade;
}

export const getCannotAccessList = _getCannotAccessList;
export const getDefaultPages = _getDefaultPages;
export const getUserTypeGrade = _getUserTypeGrade;

